import React from "react"

import Editor from '@kehila/react-page-editor';

import {cellPlugins} from "./plugins/cellPlugins"


export default class WebEditorRender extends React.Component {
    render() {

        const {page,lang} = this.props

        let content=null
        try {
            if (page?.content) content=JSON.parse(page.content)
        } catch (error) {
            console.error('Invalid legacy editor content', error)
        }

        return (
            <div style={{maxWidth:1425,padding:"2%",margin:"0 auto"}}>
                <Editor
                    cellPlugins={cellPlugins}
                    value={content}
                    lang={lang}
                    cellSpacing={{x:10,y:0}}
                    readOnly
                />
            </div>
        )
    }

}
